import { render, staticRenderFns } from "./DashboardWallet.vue?vue&type=template&id=6a295a01&scoped=true&"
import script from "./DashboardWallet.vue?vue&type=script&lang=js&"
export * from "./DashboardWallet.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWallet.vue?vue&type=style&index=0&id=6a295a01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a295a01",
  null
  
)

export default component.exports